// src/pages/SubscriptionPage.js
import React from 'react';
import { InformationCircleIcon } from '@heroicons/react/24/solid';

function SubscriptionPage() {
  return (
    <div className="bg-gray-50 min-h-screen">
      <div className="container mx-auto max-w-7xl p-4 pt-24">
        {/* Simple information card */}
        <div className="bg-white rounded-2xl shadow-lg border border-gray-200 overflow-hidden max-w-2xl mx-auto">
          <div className="p-8 lg:p-12">
            <div className="text-center">
              <InformationCircleIcon className="h-16 w-16 text-indigo-600 mx-auto mb-6" />

              <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-6">
                Subscription Information
              </h2>

              <div className="text-xl text-gray-700 max-w-md mx-auto mb-10 leading-relaxed">
                <p>
                  To activate your trial period or extend your current subscription, please get in touch with our software representative.
                </p>
                <p className="mt-4">
                  We are here to assist you with the next steps and answer any questions you may have.
                </p>
              </div>

              <div className="bg-indigo-50 border border-indigo-200 text-indigo-800 p-6 rounded-lg max-w-md mx-auto">
                <h3 className="text-xl font-semibold mb-3">Contact Us</h3>
                <p className="text-base">
                  Please reach out via your designated contact channel or email us at:
                  <a href="mailto:support@example.com" className="font-medium text-indigo-600 hover:text-indigo-800 ml-1">
                    support@juza.pro
                  </a> {/* Replace with your actual contact email */}
                </p>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SubscriptionPage;